import React, { useEffect, useState } from 'react'
import { Avatar, Button, Dropdown } from 'antd';
import { Link, useLocation } from 'react-router-dom'
import Logo from '../assets/images/logo/logo.webp'
import Login from './Login';
import ThemeRandomizer from '../utils/ThemeRandomizer';
import { capitalizeWords } from '../utils/Constants';
import { logo_holiday, logo_hotel } from '../utils/ImagePath';
import { FaChevronDown, FaHotel, FaPlane, FaRegUser, FaSignOutAlt, FaTicketAlt, FaUmbrellaBeach, FaWallet } from 'react-icons/fa';
import { setModal2Open } from '../redux/hotel/modalSlice';
import { useDispatch } from 'react-redux';


const Header = ({ setOpen, modal2Open }) => {

    let getUser = JSON.parse(localStorage.getItem('user'));
    let isUserType = JSON.parse(localStorage.getItem('isUserType'));

    const location = useLocation();

    const logout = () => {
        localStorage.clear();
        setUserStatus(null);
    }
    const dispatch = useDispatch();

    const openModal = () => {
        dispatch(setModal2Open(true));
    };

    const items = [
        {
            key: '1',
            label: (
                <>
                    <Link to="/create-profile" aria-label="View Profile" className="text-decoration-none">
                        <div className="d-flex">
                            <FaRegUser />
                            <div className="user-info">
                                <Link to="/create-profile" aria-label="View Profile" className='ms-2'>View Profile</Link>
                            </div>
                        </div>
                    </Link>

                </>
            ),
        },
        {
            key: '2',
            label: (
                <Link to="/my-booking" aria-label="My Booking" className="text-decoration-none">
                    <div className="d-flex">
                        <FaTicketAlt />
                        <div className="user-info">
                            <Link to="/my-booking" aria-label="My Booking" className='ms-2'>My Booking</Link>
                        </div>
                    </div>
                </Link>
            ),
        },
        {
            key: '3',
            label: (
                <Link to="/my-wallet" aria-label="My Wallet" className="text-decoration-none">
                    <div className="d-flex">
                        <FaWallet />
                        <div className="user-info">
                            <Link to="/my-wallet" aria-label="My Wallet" className='ms-2'>My Wallet</Link>
                        </div>
                    </div>
                </Link>
            ),
        },
        {
            key: '4',
            label: (
                <Link to="/" onClick={logout}>
                    <div className="d-flex" >
                        <FaSignOutAlt />
                        <div className="user-info">
                            <Link to="/" aria-label="Logout" className='ms-2'>Logout</Link>
                            <br />
                            {/* <p>View Profile</p> */}
                        </div>
                    </div>
                </Link>
            ),
        },
    ];

    const getLogo = () => {
        if (
            location.pathname === "/flights" ||
            location.pathname === "/flight-review" ||
            location.pathname.startsWith("/flights")
        ) {
            return Logo; // Flights logo
        } else if (
            location.pathname === "/hotels" ||
            location.pathname.startsWith("/hotels") ||
            location.pathname === "/hotel-details" ||
            location.pathname === "/hotel-payment"
        ) {
            return logo_hotel; // Hotels logo
        } else if (
            location.pathname === "/holiday" ||
            location.pathname.startsWith("/holiday") ||
            location.pathname.startsWith("/package") ||
            location.pathname.startsWith("/destination") ||
            location.pathname === "/package-home"
        ) {
            return logo_holiday;
        } else {
            return Logo;
        }
    };

    useEffect(() => {
        sessionStorage.removeItem("comeFromReview");
    }, []);

    return (
        <>
            <ThemeRandomizer />
            <div className="container-fluid bg-white navbar_cntr">
                <div className="container">
                    <header className="header" id="header">
                        <nav className="navbar">
                            <Link to='/' className="brand d-flex align-items-center" aria-label="Logo">
                                <img
                                    src={getLogo()}
                                    alt='SuperbWorldTrip'
                                    className='brand-logo'
                                    width={174}
                                    height={55}
                                />

                            </Link>

                            <div className="menu" id="menu">
                                <ul className="menu-inner">
                                    <li className="menu-item">
                                        <Link aria-label="Flights"
                                            to="/flights"
                                            className={
                                                location.pathname === "/flights" || location.pathname.startsWith("/flights") || location.pathname === "/flight-review"
                                                    ? "menu-link-active"
                                                    : "menu-link"
                                            }
                                        >
                                            <FaPlane /> Flights</Link>
                                    </li>
                                    <li className="menu-item"><Link to="/hotels" aria-label="Hotels" className={
                                        location.pathname === "/hotels" || location.pathname.startsWith("/hotels") || location.pathname === "/hotel-details" || location.pathname === "/hotel-payment" || location.pathname === "/booking-success"
                                            ? "menu-link-active"
                                            : "menu-link"
                                    }> <FaHotel /> Hotels</Link></li>

                                    <li className="menu-item"><Link
                                        to="/holiday"
                                        aria-label="Holidays" className={
                                            location.pathname.startsWith("/holiday") ||
                                                location.pathname.startsWith("/package") ||
                                                location.pathname.startsWith("/destination") ||
                                                location.pathname === "/package-home" ? "menu-link-active" : "menu-link"

                                        }><FaUmbrellaBeach /> Holidays</Link></li>

                                    <li className="menu-item"><Link
                                        to="/offers"
                                        aria-label="Offers" className={
                                            location.pathname.startsWith("/offers") ||
                                                location.pathname === "/offers" ? "menu-link-active" : "menu-link"

                                        }>
                                        <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="m20.749 12 1.104-1.908a1 1 0 0 0-.365-1.366l-1.91-1.104v-2.2a1 1 0 0 0-1-1h-2.199l-1.103-1.909a1.008 1.008 0 0 0-.607-.466.993.993 0 0 0-.759.1L12 3.251l-1.91-1.105a1 1 0 0 0-1.366.366L7.62 4.422H5.421a1 1 0 0 0-1 1v2.199l-1.91 1.104a.998.998 0 0 0-.365 1.367L3.25 12l-1.104 1.908a1.004 1.004 0 0 0 .364 1.367l1.91 1.104v2.199a1 1 0 0 0 1 1h2.2l1.104 1.91a1.01 1.01 0 0 0 .866.5c.174 0 .347-.046.501-.135l1.908-1.104 1.91 1.104a1.001 1.001 0 0 0 1.366-.365l1.103-1.91h2.199a1 1 0 0 0 1-1v-2.199l1.91-1.104a1 1 0 0 0 .365-1.367L20.749 12zM9.499 6.99a1.5 1.5 0 1 1-.001 3.001 1.5 1.5 0 0 1 .001-3.001zm.3 9.6-1.6-1.199 6-8 1.6 1.199-6 8zm4.7.4a1.5 1.5 0 1 1 .001-3.001 1.5 1.5 0 0 1-.001 3.001z"></path></g></svg>
                                        Offers
                                    </Link>
                                    </li>

                                    <li className="menu-item"><Link
                                        to="/about-us"
                                        aria-label="about-us" className={
                                            location.pathname.startsWith("/about-us") ||
                                                location.pathname === "/about-us" ? "menu-link-active" : "menu-link"

                                        }>
                                        <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="m20.749 12 1.104-1.908a1 1 0 0 0-.365-1.366l-1.91-1.104v-2.2a1 1 0 0 0-1-1h-2.199l-1.103-1.909a1.008 1.008 0 0 0-.607-.466.993.993 0 0 0-.759.1L12 3.251l-1.91-1.105a1 1 0 0 0-1.366.366L7.62 4.422H5.421a1 1 0 0 0-1 1v2.199l-1.91 1.104a.998.998 0 0 0-.365 1.367L3.25 12l-1.104 1.908a1.004 1.004 0 0 0 .364 1.367l1.91 1.104v2.199a1 1 0 0 0 1 1h2.2l1.104 1.91a1.01 1.01 0 0 0 .866.5c.174 0 .347-.046.501-.135l1.908-1.104 1.91 1.104a1.001 1.001 0 0 0 1.366-.365l1.103-1.91h2.199a1 1 0 0 0 1-1v-2.199l1.91-1.104a1 1 0 0 0 .365-1.367L20.749 12zM9.499 6.99a1.5 1.5 0 1 1-.001 3.001 1.5 1.5 0 0 1 .001-3.001zm.3 9.6-1.6-1.199 6-8 1.6 1.199-6 8zm4.7.4a1.5 1.5 0 1 1 .001-3.001 1.5 1.5 0 0 1-.001 3.001z"></path></g></svg>
                                        About Us
                                    </Link>
                                    </li>


                                    <li className="menu-item d-md-none"><Link to="#" aria-label="Login" className="menu-link">Login</Link></li>
                                    <li className="menu-item d-md-none"><Link to="#" aria-label="Register" className="menu-link">Register</Link></li>
                                </ul>
                            </div>


                            <div className='d-none d-md-block'>
                                {!isUserType ?
                                    <Button onClick={openModal} className="btn btn-primary menu-block" aria-label="login register">
                                        <span className='lh-sm'>Login/Register</span>
                                    </Button> :
                                    <Dropdown
                                        menu={{ items, }}
                                        placement="bottom"
                                        arrow={{ pointAtCenter: true, }}
                                        className="profile-name d-flex align-item-center "
                                    >
                                        <Button className="btn btn-primary" aria-label="name">
                                            <Avatar
                                                className="me-2"
                                                style={{
                                                    backgroundColor: 'rgb(253 227 207 / 51%)',
                                                    color: '#f56a00',
                                                    display: "flex",
                                                    alignItem: "center",
                                                    fontWeight: "600"
                                                }}
                                            >
                                                {`${getUser?.firstName?.charAt(0)}`}
                                            </Avatar>
                                            <span className="text-truncate me-2">Hey {capitalizeWords(getUser?.firstName)}</span><FaChevronDown />
                                        </Button>
                                    </Dropdown>
                                }
                            </div>


                            <div className="burger" onClick={() => setOpen(true)}>
                                <span className="burger-line"></span>
                                <span className="burger-line"></span>
                                <span className="burger-line"></span>
                            </div>

                        </nav>
                    </header>
                </div>
            </div >

            <Login />


        </>
    )
}

export default Header